type EvaluatedFlagEventProperties = Record<string, string>;

type SetEvaluatedFlagEventPropertiesUpdater = (
  currentProperties: EvaluatedFlagEventProperties,
) => EvaluatedFlagEventProperties;

type SetEvaluatedFlagEventPropertiesAction =
  | EvaluatedFlagEventProperties
  | SetEvaluatedFlagEventPropertiesUpdater;

let evaluatedFlagEventProperties: EvaluatedFlagEventProperties = {};

/**
 * Client-side snapshot of evaluated feature flags (`flag_<key>`) merged into
 * Segment `track` / `page` event properties by analytics middleware.
 */
function setEvaluatedFlagEventProperties(
  action: SetEvaluatedFlagEventPropertiesAction,
): void {
  const nextProperties =
    typeof action === "function"
      ? action({ ...evaluatedFlagEventProperties })
      : action;

  evaluatedFlagEventProperties = { ...nextProperties };
}

function getEvaluatedFlagEventProperties(): EvaluatedFlagEventProperties {
  return { ...evaluatedFlagEventProperties };
}

export { getEvaluatedFlagEventProperties, setEvaluatedFlagEventProperties };
